import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import {
  Settings, CreditCard, Users, HelpCircle, Award, FolderKanban,
  BookOpen, Heart
} from 'lucide-react';

const accountTiles = [
  {
    title: 'Settings',
    description: 'Profile, notifications, security, appearance, autopilot settings',
    icon: Settings,
    accentClass: 'text-blue-500',
    href: '/app/account/settings'
  },
  {
    title: 'Project Manager',
    description: 'Manage goals, strategies, projects, tasks, growth, and team access.',
    icon: FolderKanban,
    accentClass: 'text-purple-500',
    badge: { text: 'Team: Agency+' },
    href: '/app/account/project-manager'
  },
  {
    title: 'Billing',
    description: 'View subscription, invoices, and payment details',
    icon: CreditCard,
    accentClass: 'text-green-500',
    href: '/app/account/billing'
  },
  {
    title: 'Affiliates',
    description: 'Referral link, stats, and earnings',
    icon: Users,
    accentClass: 'text-pink-500',
    href: '/app/account/affiliates'
  },
  {
    title: 'Rewards',
    description: 'Rewards dashboard and status',
    icon: Award,
    accentClass: 'text-amber-500',
    href: '/app/account/rewards'
  },
  {
    title: 'Resource Toolkit',
    description: 'Guides, templates, and resources for creators',
    icon: BookOpen,
    accentClass: 'text-orange-500',
    href: '/app/account/resource-toolkit'
  },
  {
    title: 'Church Partner',
    description: 'Church and faith-based community partnerships',
    icon: Heart,
    accentClass: 'text-rose-500',
    href: '/app/account/church-partner'
  },
  {
    title: 'Support',
    description: 'Help center and contact support',
    icon: HelpCircle,
    accentClass: 'text-yellow-500',
    href: '/app/account/support'
  }
];

export default function AccountOverview() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">ACCOUNT</h1>
        <p className="text-[#8A93A6]">Hub for preferences, billing, incentives, and support</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {accountTiles.map((tile) => {
          const Icon = tile.icon;

          return (
            <Link to={tile.href} key={tile.title} className="h-full">
              <Card className="glass hover:bg-white/5 transition-all cursor-pointer h-full">
                <CardHeader>
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <Icon className={`h-5 w-5 ${tile.accentClass}`} />
                    <span className="flex-1">{tile.title}</span>
                    {tile.badge && (
                      <Badge variant="outline" className="text-xs border-white/10 text-[#C7D2E3]">
                        {tile.badge.text}
                      </Badge>
                    )}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-[#8A93A6]">{tile.description}</p>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
